import React from 'react';
import { ImSpinner2 } from 'react-icons/im';

export const Button = ({
  className,
  children,
  props,
  onClick,
  type,
  isLoading,
  disabled,
}) => (
  <button
    className={`text-white text-center font-semibold ${disabled ? "bg-grey-400 cursor-no-drop" : "bg-red-400"} hover:bg-opacity-80 rounded-lg p-2 inline-flex justify-center items-center ${className}`}
    disabled={disabled || false}
    type={type || 'button'}
    {...props}
    onClick={!isLoading ? onClick : null}
  >
    {isLoading ? <ImSpinner2 className="animate-spin" /> : children}
  </button>
);

export const ButtonShadow = ({
  className,
  children,
  props,
  onClick,
  type,
  isLoading,
  disabled,
}) => (
  <button
    className={`border-2 text-red-600 bg-white font-semibold 
      ${disabled ? "opacity-50 cursor-not-allowed" : "hover:bg-[rgba(208,1,73,0.9)] hover:text-white"} 
      rounded-lg p-2 inline-flex justify-center items-center gap-2 transition-all ${className}`}
    disabled={disabled || false}
    type={type || "button"}
    {...props}
    onClick={!isLoading ? onClick : null}
    style={{
      borderColor: "rgb(208,1,73)",
      color: "rgb(208,1,73)",
    }} 
  >
    {isLoading ? <ImSpinner2 className="animate-spin" /> : children}
  </button>
);
